import moment from "moment";
import {
  DEMOSTIC_EXCESS_BAGGAGE_KEY,
  EXTRA_BAGGAGE_KEY,
  FEE_CODES,
  INTERNATION_EXCESS_BAGGAGE_KEY,
  JOURNEY_LEVEL_SSR_CODES,
  MUSIC_KIT_BAGGAGE_KEY,
  PASSENGER_TYPE,
  PNR_LEVEL_SSR_CODES,
  SEAT_SELECTION_SSRCODE,
  SEGMENT_LEVEL_SSR_CODES,
  SPECIAL_FARE_TYPE_TEXT,
  TRAVEL_INSURANCE_SSRCODE,
  TRIPCOVERRETURNTRIPDAYSlIMIT
} from "../constants/variables";
import { SsrAvailability, sellSSRType, sellSsr } from "../dataLayer/AddonAPI";
import { CurrentBookingInState } from "../dataLayer/CurrentBookingInState";
import { getAddOnDetails } from "../dataLayer/addOnDetails";
import { SpecialRequest } from "../global";
import { deepCopy } from "../utils/jsonUtils";
import { findPrimaryContact } from "helper/contact";

export async function getPassengerType(passengerObj, selectedSpecialFare: any = {}) {
  const types = [];
  let changePaxType = false;
  const passengerTypeUpdate: any = {};

  if (typeof selectedSpecialFare.name !== "undefined") {
    if (
      selectedSpecialFare.name === "Student" ||
      selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.ARMED_FORCE ||
      selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.MEDICAL_PROFESSIONALS
    ) {
      changePaxType = true;
      passengerTypeUpdate[PASSENGER_TYPE.ADULT] = selectedSpecialFare.passengerTypeCode;
    } else if (selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.SENIOR_CITIZEN) {
      passengerTypeUpdate[PASSENGER_TYPE.SENIOR_CITIZEN] = selectedSpecialFare.passengerTypeCode;
    }
  }

  if (passengerObj.adult > 0) {
    if (changePaxType) {
      types.push({
        type: passengerTypeUpdate[PASSENGER_TYPE.ADULT],
        discountCode: passengerTypeUpdate[PASSENGER_TYPE.ADULT],
        count: passengerObj.adult
      });
    } else if (selectedSpecialFare && selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.UNACCOMPANIED_MINOR) {
      // dont add
    } else {
      types.push({
        type: PASSENGER_TYPE.ADULT,
        count: passengerObj.adult
      });
    }
  }
  if (passengerObj.seniorcitizen > 0) {
    types.push({
      type: PASSENGER_TYPE.SENIOR_CITIZEN,
      discountCode: PASSENGER_TYPE.SENIOR_CITIZEN,
      count: passengerObj.seniorcitizen
    });
  }
  if (passengerObj.extraSeat > 0) {
    if (changePaxType) {
      if (passengerObj.extraSeat > 0) {
        types.push({
          type: PASSENGER_TYPE.EXTRA_SEAT,
          count: passengerObj.extraSeat
        });
      }
    } else if (selectedSpecialFare && selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.UNACCOMPANIED_MINOR) {
      // dont add
    } else if (passengerObj.extraSeat > 0) {
      types.push({
        type: PASSENGER_TYPE.EXTRA_SEAT,
        count: passengerObj.extraSeat
      });
    }
  }
  if (passengerObj.child > 0) {
    if (selectedSpecialFare.name !== SPECIAL_FARE_TYPE_TEXT.UNACCOMPANIED_MINOR) {
      types.push({
        type: PASSENGER_TYPE.CHILD,
        count: passengerObj.child
      });
    }
  }
  if (selectedSpecialFare.name === SPECIAL_FARE_TYPE_TEXT.UNACCOMPANIED_MINOR) {
    let count = passengerObj.child;
    if (passengerObj.child === 0) {
      count = 1;
    }
    types.push({
      type: PASSENGER_TYPE.CHILD,
      count
    });
  }

  return types;
}

export function passengerCountFromCurrentBooking(passengers, passengerInContext = null) {
  const passengerCount = {
    child: 0,
    adult: 0,
    seniorcitizen: 0,
    infant: 0,
    extraSeat: 0,
    total: 0,
    childKey: [],
    adultKey: [],
    seniorcitizenKey: [],
    infantKey: [],
    extraSeatKey: []
  };
  try {
    if (typeof passengers !== "undefined") {
      for (let index = 0; index < passengers.length; index += 1) {
        const pax = passengers[index];
        if (
          pax?.passengerTypeCode === PASSENGER_TYPE.ADULT ||
          pax?.passengerTypeCode === PASSENGER_TYPE.STUDENT ||
          pax?.passengerTypeCode === PASSENGER_TYPE.MEDICAL ||
          pax?.passengerTypeCode === PASSENGER_TYPE.ARMED_FORCE
        ) {
          if (passengerInContext) {
            if (passengerInContext && passengerInContext.adult !== passengerCount.adult) {
              passengerCount.adult += 1;
              passengerCount.total += 1;
              passengerCount.adultKey.push(pax.passengerKey);
            }
          } else {
            passengerCount.adult += 1;
            passengerCount.total += 1;
            passengerCount.adultKey.push(pax.passengerKey);
          }

          if (pax?.infant != null) {
            // passenger is with infant
            passengerCount.infant += 1;
            passengerCount.infantKey.push(pax.passengerKey);
            passengerCount.total += 1;
          }
        } else if (pax?.passengerTypeCode === PASSENGER_TYPE.CHILD) {
          passengerCount.child += 1;
          passengerCount.total += 1;
          passengerCount.childKey.push(pax.passengerKey);
        } else if (pax?.passengerTypeCode === PASSENGER_TYPE.EXTRA_SEAT) {
          passengerCount.extraSeat += 1;
          passengerCount.total += 1;
          passengerCount.extraSeatKey.push(pax.passengerKey);
        } else if (pax?.passengerTypeCode === PASSENGER_TYPE.INFANT) {
          passengerCount.infant += 1;
          passengerCount.total += 1;
          passengerCount.infantKey.push(pax.passengerKey);
        } else if (pax?.passengerTypeCode === PASSENGER_TYPE.SENIOR_CITIZEN) {
          passengerCount.seniorcitizen += 1;
          passengerCount.total += 1;
          passengerCount.seniorcitizenKey.push(pax.passengerKey);
          if (pax?.infant != null) {
            // passenger is with infant
            passengerCount.infant += 1;
            passengerCount.infantKey.push(pax.passengerKey);
            passengerCount.total += 1;
          }
        }
      }
      return passengerCount;
    }
    return passengerCount;
  } catch (error) {
    console.warn(error);
  }
}

export async function getArrayOfPassengers(
  userInfo,
  passengerCount,
  selectedSpecialFare,
  isAddingTravelDetails = false
) {
  const passengerList = [];
  const extraPaxKeys = deepCopy(passengerCount?.extraSeatKey);
  try {
    if (typeof userInfo[PASSENGER_TYPE.ADULT] !== "undefined") {
      for (let index = 0; index < userInfo[PASSENGER_TYPE.ADULT].length; index++) {
        const adultPassenger = userInfo[PASSENGER_TYPE.ADULT][index];

        const passengerDetails = {
          info: {
            gender: adultPassenger.gender
          },
          name: {
            first: adultPassenger.first,
            last: adultPassenger.last
          },
          discountCode: undefined,
          passengerKey: passengerCount.adultKey[index]
        };
        if (adultPassenger?.middle) {
          passengerDetails["name"]["middle"] = adultPassenger?.middle;
        }
        if (adultPassenger?.dateOfBirth) {
          passengerDetails["info"]["dateOfBirth"] = adultPassenger?.dateOfBirth;
        }
        if (adultPassenger?.travelDetails && isAddingTravelDetails) {
          passengerDetails["travelDetails"] = adultPassenger?.travelDetails;
          passengerDetails["passengerType"] = PASSENGER_TYPE.ADULT;
        }
        if (extraPaxKeys.length > 0 && adultPassenger?.isExtraSeatRequested) {
          passengerDetails["duoSeatPaxKey"] = extraPaxKeys[0];
          extraPaxKeys.shift();
        }
        if (selectedSpecialFare) {
          passengerDetails.discountCode = selectedSpecialFare.passengerTypeCode;
        }
        passengerList.push(passengerDetails);
      }
    }
    if (typeof userInfo[PASSENGER_TYPE.CHILD] !== "undefined") {
      for (let index = 0; index < userInfo[PASSENGER_TYPE.CHILD].length; index++) {
        const childPassenger = userInfo[PASSENGER_TYPE.CHILD][index];

        const passengerDetails = {
          info: {
            gender: childPassenger.gender,
            dateOfBirth: childPassenger.dateOfBirth
          },
          name: {
            first: childPassenger.first,
            last: childPassenger.last
          },

          passengerKey: passengerCount.childKey[index]
        };
        if (childPassenger?.middle) {
          passengerDetails["name"]["middle"] = childPassenger?.middle;
        }
        if (childPassenger?.travelDetails && isAddingTravelDetails) {
          passengerDetails["travelDetails"] = childPassenger?.travelDetails;
          passengerDetails["passengerType"] = PASSENGER_TYPE.CHILD;
        }
        if (extraPaxKeys.length > 0 && childPassenger?.isExtraSeatRequested) {
          passengerDetails["duoSeatPaxKey"] = extraPaxKeys[0];
          extraPaxKeys.shift();
        }
        passengerList.push(passengerDetails);
      }
    }
    if (typeof userInfo[PASSENGER_TYPE.SENIOR_CITIZEN] !== "undefined") {
      for (let index = 0; index < userInfo[PASSENGER_TYPE.SENIOR_CITIZEN].length; index++) {
        const seniorPassenger = userInfo[PASSENGER_TYPE.SENIOR_CITIZEN][index];
        const passengerDetails = {
          info: {
            gender: seniorPassenger.gender,
            dateOfBirth: seniorPassenger.dateOfBirth
          },
          name: {
            first: seniorPassenger.first,
            last: seniorPassenger.last
          },
          discountCode: PASSENGER_TYPE.SENIOR_CITIZEN,
          passengerKey: passengerCount.seniorcitizenKey[index]
        };
        if (seniorPassenger?.middle) {
          passengerDetails["name"]["middle"] = seniorPassenger?.middle;
        }
        if (seniorPassenger?.travelDetails && isAddingTravelDetails) {
          passengerDetails["travelDetails"] = seniorPassenger?.travelDetails;
          passengerDetails["passengerType"] = PASSENGER_TYPE.SENIOR_CITIZEN;
        }
        if (extraPaxKeys.length > 0 && seniorPassenger?.isExtraSeatRequested) {
          passengerDetails["duoSeatPaxKey"] = extraPaxKeys[0];
          extraPaxKeys.shift();
        }
        passengerList.push(passengerDetails);
      }
    }
    if (typeof userInfo[PASSENGER_TYPE.INFANT] !== "undefined" && isAddingTravelDetails) {
      for (let index = 0; index < userInfo[PASSENGER_TYPE.INFANT].length; index++) {
        const infantPassenger = userInfo[PASSENGER_TYPE.INFANT][index];
        const passengerDetails = {
          info: {
            gender: infantPassenger.gender,
            dateOfBirth: infantPassenger.dateOfBirth
          },
          name: {
            first: infantPassenger.first,
            last: infantPassenger.last
          },
          discountCode: PASSENGER_TYPE.INFANT
        };
        if (infantPassenger?.middle) {
          passengerDetails["name"]["middle"] = infantPassenger?.middle;
        }
        if (infantPassenger?.travelDetails && isAddingTravelDetails) {
          passengerDetails["travelDetails"] = infantPassenger?.travelDetails;
          passengerDetails["passengerKey"] = infantPassenger?.travelDetails?.paxKey;
          passengerDetails["passengerType"] = PASSENGER_TYPE.INFANT;
        }
        passengerList.push(passengerDetails);
      }
    }
    return passengerList;
  } catch (error) {
    console.warn(error);
  }
  return passengerList;
}

export async function getPrimaryUserDetails(userInfo) {
  let response = { first: "first", last: "last" };
  let gotUserInfo = false;
  if (typeof userInfo[PASSENGER_TYPE.ADULT] !== "undefined") {
    for (let index = 0; index < userInfo[PASSENGER_TYPE.ADULT].length; index++) {
      const adultPassenger = userInfo[PASSENGER_TYPE.ADULT][index];
      response = { first: adultPassenger.first, last: adultPassenger.last };
      gotUserInfo = true;
      break;
    }
  }
  if (typeof userInfo[PASSENGER_TYPE.CHILD] !== "undefined" && !gotUserInfo) {
    for (let index = 0; index < userInfo[PASSENGER_TYPE.CHILD].length; index++) {
      const childPassenger = userInfo[PASSENGER_TYPE.CHILD][index];
      response = { first: childPassenger.first, last: childPassenger.first };
      gotUserInfo = true;
      break;
    }
  }
  if (typeof userInfo[PASSENGER_TYPE.SENIOR_CITIZEN] !== "undefined" && !gotUserInfo) {
    for (let index = 0; index < userInfo[PASSENGER_TYPE.SENIOR_CITIZEN].length; index++) {
      const seniorPassenger = userInfo[PASSENGER_TYPE.SENIOR_CITIZEN][index];
      response = { first: seniorPassenger.first, last: seniorPassenger.first };
      gotUserInfo = true;
      break;
    }
  }
  return response;
}
export async function getContactObj(primaryContact, userInfo = { first: "first", last: "last" }, cusIdNo?: string) {
  const contact = {
    customerNumber: cusIdNo,
    emailAddress: primaryContact.email,
    name: {
      first: userInfo.first,
      last: userInfo.last
    },
    contactTypeCode: "P",
    phoneNumbers: [
      {
        number: primaryContact.mobile,
        type: "Other"
      }
    ]
  };
  return contact;
}

export function passengerSummaryObjrebuild(userInfo) {
  const response = [];
  if (userInfo) {
    for (let index = 0; index < userInfo.length; index++) {
      const user = userInfo[index];
      const middleName = user.name?.middle;
      const fullname = middleName ? `${user.name?.first} ${middleName} ${user?.name?.last}` : `${user.name?.first} ${user?.name?.last}`;
      const tempPassengerObj = {
        first: user?.name?.first,
        middle: user?.name?.middle,
        last: user?.name?.last,
        fullName: fullname,
        passengerType: user?.passengerTypeCode,
        passengerKey: user.passengerKey
      };
      response.push(tempPassengerObj);
    }
    return response;
  }
}

export async function passengerSummaryList(bookingInState, paymentSummary = null) {
  // todo :: need to remove this function ,
  const responseList = [];
  const passengerDetailsObj = {};
  try {
    let passengerList = [];
    let tempBookingInState: any = {};
    if (typeof bookingInState?.passengers !== "undefined") {
      passengerList = bookingInState?.passengers;
      tempBookingInState = bookingInState;
    }
    if (typeof bookingInState.data !== "undefined" && typeof bookingInState.data.passengers !== "undefined") {
      passengerList = bookingInState.data.passengers;
      tempBookingInState = bookingInState.data;
    }
    try {
      if (typeof passengerList !== "undefined") {
        for (let index = 0; index < passengerList.length; index++) {
          const element = passengerList[index];
          passengerDetailsObj[element.passengerKey] = [];
          const tempPassengerObj = {
            first: element?.name?.first,
            middle: element?.name?.middle,
            last: element?.name?.last,
            fullName: `${element.name?.first} ${element?.name?.last}`,
            passengerType: element.passengerTypeCode,
            passengerKey: element.passengerKey
          };
          if (paymentSummary != null && typeof paymentSummary[tempPassengerObj.passengerType] !== "undefined") {
            tempPassengerObj.fare =
              parseInt(paymentSummary[tempPassengerObj.passengerType]?.farePrice?.amount) /
              parseInt(paymentSummary[tempPassengerObj.passengerType]?.farePrice?.count);
          }
          passengerDetailsObj[element.passengerKey].info = tempPassengerObj;
          responseList.push(tempPassengerObj);
        }
        // checking for seat :
        if (typeof tempBookingInState !== "undefined" && typeof tempBookingInState?.seats !== "undefined") {
          for (let index = 0; index < tempBookingInState?.seats.length; index++) {
            const seatForJourney = tempBookingInState.seats[index];
            const passengerTemp2 = seatForJourney?.segments?.[0]?.passengerSegment; // first segment seat diplsy
            for (let passengerInd = 0; passengerInd < passengerTemp2.length; passengerInd++) {
              const pax = passengerTemp2[passengerInd];
              if (typeof passengerDetailsObj[pax.passengerKey] === "undefined") {
                passengerDetailsObj[pax.passengerKey] = [];
              }
              if (pax.seats.length > 0) {
                passengerDetailsObj[pax.passengerKey].seats = pax.seats?.[0];
                if (pax.seats?.[0]?.seatInformation?.propertyList?.[0]) {
                  passengerDetailsObj[pax.passengerKey].seats.seatType =
                    pax.seats?.[0]?.seatInformation?.propertyList?.[0]?.key;
                }
              }
            }
          }
        }
      } else {
        console.warn(bookingInState);
      }
    } catch (error) {
      console.warn(error);
    }
  } catch (error) {
    console.warn(error);
  }

  return responseList;
}
export const isSegmentLevelSsr = (ssrCode) => {
  // return false if ssr is segment level :
  const segmentLevelSsrcodes = SEGMENT_LEVEL_SSR_CODES;
  if (segmentLevelSsrcodes.includes(ssrCode)) {
    return true;
  }
  return false;
};

export const isJourneyLevelSsr = (ssrCode) => {
  if (JOURNEY_LEVEL_SSR_CODES.includes(ssrCode)) {
    return true;
  }
  if (DEMOSTIC_EXCESS_BAGGAGE_KEY.includes(ssrCode)) {
    return true;
  }
  
  if (INTERNATION_EXCESS_BAGGAGE_KEY.includes(ssrCode)) {
    return true;
  }

  if (EXTRA_BAGGAGE_KEY.includes(ssrCode)) {
    return true;
  }
  
  if (MUSIC_KIT_BAGGAGE_KEY.includes(ssrCode)) {
    return true;
  }
  return false;
};

export const isPNRLevelSsr = (ssrCode) => {
  // return false if ssr is segment level :
  const segmentLevelSsrcodes = PNR_LEVEL_SSR_CODES;
  if (segmentLevelSsrcodes.includes(ssrCode)) {
    return true;
  }
  return false;
};

export async function passengerSummaryListWithSeat(
  bookingInState,
  paymentSummary = null,
  bookingInRedux = null,
  story = null,
  bookingSummaryPage = false
) {
  const responseList = [];
  const passengerDetailsObj: any = {};
  if (!story) {
    const response = await getAddOnDetails();
    if (response) {
      story = response?.story;
    }
  }
  const adhonsList = story?.content?.ssr;
  let isSeatSelected = false;
  let isAdhonsSelected = false;
  const journeyObj = {};
  let passengerList = [];
  let addedSsrList: any = [];
  let tempBookingInState: any = {};
  const newJourneyData: any = {};
  try {
    if (typeof bookingInState?.passengers !== "undefined") {
      passengerList = bookingInState?.passengers;
      tempBookingInState = bookingInState;
    }

    if (typeof bookingInState.data !== "undefined" && typeof bookingInState.data.passengers !== "undefined") {
      passengerList = bookingInState.data.passengers;
      tempBookingInState = bookingInState.data;
    }

    const TimeDifference =
      tempBookingInState?.journeys.length >= 2
        ? Math.abs(
            new Date(tempBookingInState?.journeys?.[1]?.designator?.departure).getTime() -
              new Date(tempBookingInState?.journeys?.[0]?.designator?.departure).getTime()
          )
        : 0;
    const onboardAndReturnDaysDiff =
      tempBookingInState?.journeys.length >= 2 ? Math.ceil(TimeDifference / (1000 * 60 * 60 * 24)) : 0;
    const isSecondJourneyIsMoreThenLimitTime = onboardAndReturnDaysDiff > TRIPCOVERRETURNTRIPDAYSlIMIT;
    try {
      if (typeof passengerList !== "undefined") {
        for (let index = 0; index < passengerList.length; index += 1) {
          const element = passengerList[index];
          passengerDetailsObj[element.passengerKey] = [];
          const middleName = element.name?.middle;
          const fullname = middleName ? `${element.name?.first} ${middleName} ${element?.name?.last}` : `${element.name?.first} ${element?.name?.last}`
          const tempPassengerObj = {
            first: element?.name?.first,
            last: element?.name?.last,
            fullName: fullname,
            passengerType: element?.passengerTypeCode,
            passengerKey: element.passengerKey
          };
          if (paymentSummary != null && typeof paymentSummary[tempPassengerObj.passengerType] !== "undefined") {
            tempPassengerObj.fare = bookingSummaryPage ? paymentSummary[tempPassengerObj.passengerType]?.farePrice?.journeysFare 
              : 
            parseFloat(paymentSummary[tempPassengerObj.passengerType]?.farePrice?.amount);
            // tempPassengerObj['fare'] = parseInt(paymentSummary[tempPassengerObj.passengerType]?.farePrice?.amount)/parseInt(paymentSummary[tempPassengerObj.passengerType]?.farePrice?.count);
          }
          tempPassengerObj.isHavingInfant = false;
          if (element.infant != null && element.infant.name != null) {
            tempPassengerObj.isHavingInfant = true;
            tempPassengerObj.infantDetails = {
              first_name: element?.infant?.name?.first,
              last_name: element?.infant?.name?.last,
              gender: element?.infant?.gender,
              charges: element?.infant?.fees,
              dateOfBirth: element?.infant?.dateOfBirth
            };
          }
          passengerDetailsObj[element.passengerKey].info = tempPassengerObj;
          responseList.push(tempPassengerObj);
        }

        for (let index = 0; index < tempBookingInState.journeys.length; index += 1) {
          const journeyInd = deepCopy(tempBookingInState.journeys[index]);

          const tempKey = `${journeyInd?.designator?.origin}-${journeyInd?.designator?.destination}`;
          if (typeof journeyObj[tempKey] === "undefined") {
            journeyObj[tempKey] = {};
            journeyObj[tempKey].passengerInfo = {};
            journeyObj[tempKey].ssrs = [];
            journeyObj[tempKey].complimentarySsrs = [];
            journeyObj[tempKey].segmentInfo = {};
          }
          for (let jouInd = 0; jouInd < journeyInd.segments.length; jouInd += 1) {
            const segment = journeyInd.segments[jouInd];
            const isConnectingFlight = journeyInd.segments.length > 1 ? true : false;
            for (let segInd = 0; segInd < segment?.passengerSegment.length; segInd += 1) {
              const passengerSegment = segment?.passengerSegment[segInd];
              // reset the ssr added ::
              const segmentKey = `${segment?.designator?.origin}-${segment?.designator?.destination}`;
              const journeyKey = `${journeyInd?.designator?.origin}-${journeyInd?.designator?.destination}`;
              if (!journeyObj[tempKey].segmentInfo[segmentKey]) {
                journeyObj[tempKey].segmentInfo[segmentKey] = {};
                journeyObj[tempKey].segmentInfo[segmentKey].passengerInfo = {};
                journeyObj[tempKey].segmentInfo[segmentKey].ssrs = [];

                newJourneyData[segmentKey] = {};
                newJourneyData[segmentKey].passengerInfo = {};
                newJourneyData[segmentKey].ssrs = [];
                newJourneyData[segmentKey].complimentarySsrs = [];
                newJourneyData[segmentKey].isMultipleSegment = journeyInd.segments.length > 1;
                newJourneyData[segmentKey].journeyKey = tempKey;
                newJourneyData[segmentKey].departuareTime = segment?.designator?.departure;
                newJourneyData[segmentKey].displayStatus =
                  moment.duration(moment(segment?.designator?.departure).diff(moment.now())).asHours() > 0;

                // adding hold/fee code to display from redux:
                if (bookingInRedux?.runningAddhons) {
                  const getAllHoldSSRCode = FEE_CODES;
                  for (let holdSsrInd = 0; holdSsrInd < getAllHoldSSRCode.length; holdSsrInd += 1) {
                    const ssrCodes = getAllHoldSSRCode[holdSsrInd];
                    let tempFeeCode = {};
                    if (
                      bookingInRedux?.runningAddhons?.[ssrCodes] &&
                      bookingInRedux?.runningAddhons?.[ssrCodes]?.isActive == true
                    ) {
                      tempFeeCode = {};
                      const tempAdhoData = adhonsList.filter((ssr) => ssr.ssrCode === ssrCodes);
                      tempFeeCode.details = tempAdhoData[0];
                      tempFeeCode.isPNRLevel = isPNRLevelSsr(ssrCodes);
                      if (index > 0 && tempFeeCode.isPNRLevel) {
                        tempFeeCode.totalAmount = "-";
                        addedSsrList.push(ssrCodes);
                      } else {
                        if (addedSsrList.includes(ssrCodes)) {
                          tempFeeCode.totalAmount = "-";
                        } else {
                          addedSsrList.push(ssrCodes);
                          tempFeeCode.totalAmount = bookingInRedux.addhosFare[ssrCodes];
                        }
                      }

                      tempFeeCode.count = Object.keys(passengerDetailsObj).length;
                      tempFeeCode.ssrCode = ssrCodes;
                      tempFeeCode.code = ssrCodes;
                      tempFeeCode.isFeeCode = true;
                      tempFeeCode.isJourneyLevel = isSegmentLevelSsr(ssrCodes);
                      tempFeeCode.isPNRLevel = isPNRLevelSsr(ssrCodes);
                      tempFeeCode.showIncludedText = tempFeeCode.totalAmount === "-" ? true : false;
                      tempFeeCode.isDisplayStatus = true;
                      tempFeeCode.isConnectingFlight = journeyInd.segments.length > 1 ? true : false;
                      if (ssrCodes === TRAVEL_INSURANCE_SSRCODE && isSecondJourneyIsMoreThenLimitTime && index > 0) {
                        tempFeeCode.isDisplayStatus = false;
                      }
                      newJourneyData[segmentKey].ssrs[ssrCodes] = tempFeeCode;
                    }
                  }
                }
              }
              // seats
              const { seats } = passengerSegment;

              if (typeof passengerDetailsObj[passengerSegment.passengerKey] === "undefined") {
                passengerDetailsObj[passengerSegment.passengerKey] = [];
                passengerDetailsObj[passengerSegment.passengerKey][segmentKey] = [];

                passengerDetailsObj[passengerSegment.passengerKey].isAdhonsSelected = isAdhonsSelected;
                passengerDetailsObj[passengerSegment.passengerKey].isSeatSelected = isSeatSelected;
                journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].isSeatSelected = isSeatSelected;
                journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].isAdhonsSelected = isAdhonsSelected;

                newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].isSeatSelected = isSeatSelected;
                newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].isAdhonsSelected =
                  isAdhonsSelected;

                if (typeof journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE] === "undefined") {
                  journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE] = {
                    count: 1
                  };
                } else {
                  journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE].count += 1;
                }
                if (journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE]) {
                  journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE] = { count: 1 };
                } else {
                  journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE].count += 1;
                }
                if (newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE]) {
                  newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE].count += 1;
                } else {
                  newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE] = {
                    count: 1,
                    isDisplayStatus: true,
                    isConnectingFlight: journeyInd.segments.length > 1 ? true : false
                  };
                }
              }
              if (typeof (journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey] === "undefined")) {
                journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey] = {};
                journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].info = deepCopy(
                  passengerDetailsObj[passengerSegment.passengerKey].info
                );

                newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey] = {};
                if (bookingSummaryPage) {
                  let travelInfo = {}
                  if (isConnectingFlight) {
                    let totalFare = 0
                    const journeyFares = passengerDetailsObj[passengerSegment.passengerKey].info.fare.filter((segment) => segment[journeyKey])
                    journeyFares.forEach(journeyFare => {
                      totalFare = totalFare + journeyFare[journeyKey]
                    });
                    travelInfo[`${journeyKey}`] = totalFare
                  } else {
                    travelInfo = passengerDetailsObj[passengerSegment.  passengerKey].info.fare.find((segment) => segment[segmentKey])
                  }
                  let tempInfo = deepCopy(passengerDetailsObj[passengerSegment.passengerKey].info);
                  tempInfo.fare = travelInfo[isConnectingFlight ? journeyKey : segmentKey]
                  newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].info = tempInfo
                } else {
                  newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].info = deepCopy(
                    passengerDetailsObj[passengerSegment.passengerKey].info
                  );
                }
              }

              if (
                typeof (
                  journeyObj[tempKey].segmentInfo[segmentKey].passengerInfo[passengerSegment.passengerKey] ===
                  "undefined"
                )
              ) {
                journeyObj[tempKey].segmentInfo[segmentKey].passengerInfo[passengerSegment.passengerKey] = {};
                journeyObj[tempKey].segmentInfo[segmentKey].passengerInfo[passengerSegment.passengerKey].info =
                  passengerDetailsObj[passengerSegment.passengerKey].info;
              }
              if (seats.length > 0) {
                passengerDetailsObj[passengerSegment.passengerKey].seats = seats?.[0];
                if (typeof journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE] === "undefined") {
                  journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE] = {
                    count: seats.length,
                    ssrCode: SEAT_SELECTION_SSRCODE,
                    details: { title: "Seat Selection" }
                  };
                } else {
                  journeyObj[tempKey].ssrs[SEAT_SELECTION_SSRCODE].count += seats.length;
                }

                if (!journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE]) {
                  journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE] = {
                    count: seats.length,
                    ssrCode: SEAT_SELECTION_SSRCODE,
                    details: { title: "Seat Selection" }
                  };
                } else {
                  journeyObj[tempKey].segmentInfo[segmentKey].ssrs[SEAT_SELECTION_SSRCODE].count += seats.length;
                }
                if (newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE]) {
                  newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE].count += seats.length;
                } else {
                  newJourneyData[segmentKey].ssrs[SEAT_SELECTION_SSRCODE] = {
                    count: seats.length,
                    isDisplayStatus: true,
                    isConnectingFlight: journeyInd.segments.length > 1 ? true : false,
                    ssrCode: SEAT_SELECTION_SSRCODE,
                    details: { title: "Seat Selection" }
                  };
                }

                journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].seats = seats;

                newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].seats = seats;
                newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].isSeatSelected =
                  seats.length > 0 ? true : false;

                if (seats?.seatInformation?.propertyList?.[0]) {
                  isSeatSelected = true;
                  passengerDetailsObj[passengerSegment.passengerKey].seats.seatType =
                    seats?.seatInformation?.propertyList?.[0]?.key;
                  passengerDetailsObj[passengerSegment.passengerKey].isSeatSelected = isSeatSelected;
                  journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].seats.seatType =
                    seats?.seatInformation?.propertyList?.[0]?.key;
                  journeyObj[tempKey].passengerInfo[passengerSegment.passengerKey].isSeatSelected = isSeatSelected;

                  newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].seats.seatType =
                    seats?.seatInformation?.propertyList?.[0]?.key;
                  newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey].isSeatSelected =
                    isSeatSelected;
                }
              } else {
                isSeatSelected = false;
              }

              // ssr
              const { ssrs } = passengerSegment;
              if (ssrs !== undefined) {
                if (typeof passengerDetailsObj[passengerSegment.passengerKey] === "undefined") {
                  passengerDetailsObj[passengerSegment.passengerKey] = [];
                }
                if (ssrs.length > 0) {
                  if (typeof passengerDetailsObj[passengerSegment.passengerKey].ssrs === "undefined") {
                    passengerDetailsObj[passengerSegment.passengerKey].ssrs = [];
                  }
                  if (!passengerDetailsObj[passengerSegment.passengerKey][segmentKey]) {
                    passengerDetailsObj[passengerSegment.passengerKey][segmentKey] = [];
                    passengerDetailsObj[passengerSegment.passengerKey][segmentKey].ssrs = {};
                  }

                  if (typeof passengerDetailsObj[passengerSegment.passengerKey].complimentarySsrs === "undefined") {
                    passengerDetailsObj[passengerSegment.passengerKey].complimentarySsrs = [];
                  }
                  if (!passengerDetailsObj[passengerSegment.passengerKey][segmentKey].complimentarySsrs) {
                    passengerDetailsObj[passengerSegment.passengerKey][segmentKey].complimentarySsrs = [];
                  }

                  // the ssrs array will contain ssr multiple time as few ssrs are at segment level
                  const ssrsAdded = [];
                  for (let ssrInd = 0; ssrInd < ssrs.length; ssrInd += 1) {
                    const ssrsItem = ssrs[ssrInd];
                    const tempResult = adhonsList.filter((ad) => {
                      if (ad.ssrCode === ssrsItem.ssrCode) return ad;
                    });
                    ssrsItem.details = tempResult[0];
                    isAdhonsSelected = true;
                    let dontAddSsrInCount = false;
                    if (ssrsAdded.includes(ssrsItem.ssrCode)) {
                      if (isSegmentLevelSsr(ssrsItem.ssrCode)) {
                        dontAddSsrInCount = true;
                      }
                    } else {
                      ssrsAdded.push(ssrsItem.ssrCode);
                    }

                    if (ssrsItem?.inBundle) {
                      // if inbundle is true ; that mean it is a complement meal : free of cost
                      if (typeof journeyObj[tempKey].complimentarySsrs[ssrsItem.ssrCode] === "undefined") {
                        journeyObj[tempKey].complimentarySsrs[ssrsItem.ssrCode] = ssrsItem;
                      } else {
                        journeyObj[tempKey].complimentarySsrs[ssrsItem.ssrCode].count += 1;
                      }
                      if (typeof newJourneyData[segmentKey].complimentarySsrs[ssrsItem.ssrCode] === "undefined") {
                        newJourneyData[segmentKey].complimentarySsrs[ssrsItem.ssrCode] = deepCopy(ssrsItem);
                        newJourneyData[segmentKey].complimentarySsrs[ssrsItem.ssrCode].isDisplayStatus = true;
                      } else {
                        newJourneyData[segmentKey].complimentarySsrs[ssrsItem.ssrCode].count =
                          newJourneyData[segmentKey].complimentarySsrs[ssrsItem.ssrCode].count + 1;
                      }
                      passengerDetailsObj[passengerSegment.passengerKey].complimentarySsrs.push(ssrsItem);
                      passengerDetailsObj[passengerSegment.passengerKey][segmentKey].complimentarySsrs.push(ssrsItem);
                    } else {
                      if (typeof journeyObj[tempKey].ssrs[ssrsItem.ssrCode] === "undefined") {
                        journeyObj[tempKey].ssrs[ssrsItem.ssrCode] = ssrsItem;
                        journeyObj[tempKey].ssrs[ssrsItem.ssrCode].isJourneyLevel = isSegmentLevelSsr(ssrsItem.ssrCode);
                      } else if (!dontAddSsrInCount) {
                        journeyObj[tempKey].ssrs[ssrsItem.ssrCode].count += 1;
                      }

                      if (typeof journeyObj[tempKey].segmentInfo[segmentKey].ssrs[ssrsItem.ssrCode] === "undefined") {
                        journeyObj[tempKey].segmentInfo[segmentKey].ssrs[ssrsItem.ssrCode] = deepCopy(ssrsItem);
                      } else if (!dontAddSsrInCount) {
                        journeyObj[tempKey].segmentInfo[segmentKey].ssrs[ssrsItem.ssrCode].count += 1;
                      }

                      // newjourneyData object check
                      if (typeof newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode] === "undefined") {
                        newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode] = deepCopy(ssrsItem);
                        newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].isDisplayStatus = true;
                        newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].isJourneyLevel = isSegmentLevelSsr(
                          ssrsItem.ssrCode
                        );
                        newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].isConnectingFlight =
                          journeyInd.segments.length > 1 ? true : false;
                        if (newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].isJourneyLevel) {
                          if (jouInd > 0) {
                            newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].showIncludedText = true;
                          } else {
                            newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].showIncludedText = false;
                          }
                        }
                      } else if (!dontAddSsrInCount) {
                        newJourneyData[segmentKey].ssrs[ssrsItem.ssrCode].count += 1;
                      }

                      passengerDetailsObj[passengerSegment.passengerKey].ssrs.push(ssrsItem);
                      if (passengerDetailsObj[passengerSegment.passengerKey][segmentKey]["ssrs"][ssrsItem.ssrCode]) {
                        passengerDetailsObj[passengerSegment.passengerKey][segmentKey]["ssrs"][
                          ssrsItem.ssrCode
                        ].count += 1;
                      } else {
                        passengerDetailsObj[passengerSegment.passengerKey][segmentKey]["ssrs"][ssrsItem.ssrCode] =
                          deepCopy(ssrsItem);
                      }
                    }

                    passengerDetailsObj[passengerSegment.passengerKey].isAdhonsSelected = isAdhonsSelected;
                    if (!newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey]["ssrs"]) {
                      newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey]["ssrs"] = [];
                    }

                    newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey]["ssrs"] = deepCopy(
                      passengerDetailsObj[passengerSegment.passengerKey][segmentKey].ssrs
                    );

                    newJourneyData[segmentKey].passengerInfo[passengerSegment.passengerKey]["complimentarySsrs"] =
                      deepCopy(passengerDetailsObj[passengerSegment.passengerKey][segmentKey].complimentarySsrs);
                  }
                }
              }
            }
          }
        }
      } else {
        console.warn(bookingInState);
      }
    } catch (error) {
      console.warn(error);
    }
  } catch (error) {
    console.warn(error);
  }
  passengerDetailsObj.displayAdhosList = isAdhonsSelected;
  return newJourneyData;
}

export async function getPassengerAbilitySSR(story: any) {
  try {
    if (!story.content) {
      const response = await getAddOnDetails();
      if (response) {
        story = response?.story;
      }
    }
    const addOns = story.content.special_assistance[0]?.listItems;
    const avaliableSsr: any = await SsrAvailability();

    const ssrAva = avaliableSsr?.data?.ssrAvailabilityv2.journeySsrs;
    const mobillitySsr = [];
    const impairement = [];
    const passengerForMobilitySsr: any = [];
    const passengerForImpairement: any = [];

    const journeyCount = ssrAva.length;

    if (addOns && ssrAva) {
      for (let index = 0; index < addOns.length; index++) {
        const adhos = addOns[index];
        if (adhos.title === "Mobility") {
          for (let mobInd = 0; mobInd < adhos.listItems.length; mobInd++) {
            const mobAdhos = adhos.listItems[mobInd];
            const journeyLevelSsr = [];
            for (let journeyIndex = 0; journeyIndex < journeyCount; journeyIndex++) {
              const journeySsrs = ssrAva[journeyIndex]?.ssrs || [];
              const currentSsrForJourney = journeySsrs.find((ssr) => ssr.ssrCode === mobAdhos.ssrCode);

              if (currentSsrForJourney) {
                journeyLevelSsr.push(currentSsrForJourney);
              } else {
                journeyLevelSsr.push({
                  available: 0,
                  ssrCode: mobAdhos.ssrCode,
                  name: mobAdhos.body,
                  passengersAvailability: [],
                  seatDependent: false,
                  ssrType: "Standard"
                });
              }
            }

            const firstJourneySsr = journeyLevelSsr[0];
            const ssrObject = {
              displayText: mobAdhos.body,
              ssrCode: mobAdhos.ssrCode,
              passengersAvailability: firstJourneySsr.passengersAvailability || [],
              name: firstJourneySsr.name || mobAdhos.body,
              seatDependent: firstJourneySsr.seatDependent || false,
              ssrType: firstJourneySsr.ssrType || "Standard",
              journeyLevelSsr
            };
            mobillitySsr.push(ssrObject);
          }
        }

        if (adhos.title === "Impairment") {
          for (let mobInd = 0; mobInd < adhos.listItems.length; mobInd++) {
            const mobAdhos = adhos.listItems[mobInd];
            const journeyLevelSsr = [];

            for (let journeyIndex = 0; journeyIndex < journeyCount; journeyIndex++) {
              const journeySsrs = ssrAva[journeyIndex]?.ssrs || [];
              const currentSsrForJourney = journeySsrs.find((ssr) => ssr.ssrCode === mobAdhos.ssrCode);

              if (currentSsrForJourney) {
                journeyLevelSsr.push(currentSsrForJourney);
              } else {
                journeyLevelSsr.push({
                  available: 0,
                  ssrCode: mobAdhos.ssrCode,
                  name: mobAdhos.body,
                  passengersAvailability: [],
                  seatDependent: false,
                  ssrType: "Standard"
                });
              }
            }

            const firstJourneySsr = journeyLevelSsr[0];
            const ssrObject = {
              displayText: mobAdhos.body,
              ssrCode: mobAdhos.ssrCode,
              passengersAvailability: firstJourneySsr.passengersAvailability || [],
              name: firstJourneySsr.name || mobAdhos.body,
              seatDependent: firstJourneySsr.seatDependent || false,
              ssrType: firstJourneySsr.ssrType || "Standard",
              journeyLevelSsr
            };
            impairement.push(ssrObject);
          }
        }
      }
    }
    for (let index = 0; index < mobillitySsr.length; index++) {
      const passengers = mobillitySsr[index].passengersAvailability;
      if (passengers && passengers.length > 0) {
        passengers.map((passenger, paxIndex) => {
          if (typeof passengerForMobilitySsr[paxIndex] === "undefined") {
            passengerForMobilitySsr[paxIndex] = [];
          }
          if (passenger?.key && passenger?.value?.ssrKey) {
            passengerForMobilitySsr[paxIndex][passenger.key] = {
              ssrKey: passenger.value.ssrKey,
              count: 1
            };
          }
        });
      }
    }

    for (let index = 0; index < impairement.length; index++) {
      const passengers = impairement[index].passengersAvailability;
      if (passengers && passengers.length > 0) {
        passengers.map((passenger, paxIndex) => {
          if (typeof passengerForImpairement[paxIndex] === "undefined") {
            passengerForImpairement[paxIndex] = [];
          }
          if (passenger?.key && passenger?.value?.ssrKey) {
            passengerForImpairement[paxIndex][passenger.key] = {
              ssrKey: passenger?.value?.ssrKey,
              count: 1
            };
          }
        });
      }
    }

    const response = {
      mobility: mobillitySsr,
      impairement,
      passengerForMobility: passengerForMobilitySsr,
      PassengerForImpairement: passengerForImpairement
    };
    return response;
  } catch (error) {
    console.warn(error);
    return null;
  }
}

export async function sellPassengerSsr(ssrRequestList: String[]): Promise<boolean> {
  try {
    const ssrKeyList: sellSSRType[] = [];
    ssrRequestList.forEach((ssrRequestKey) => {
      ssrKeyList.push({
        ssrKey: ssrRequestKey,
        count: 1
      });
    });

    await sellSsr(ssrKeyList);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
}

export function isPassengerIsFilled(currentBookingInState) {
  let res = true;
  try {
    if (
      currentBookingInState &&
      typeof currentBookingInState?.passengers !== "undefined" &&
      currentBookingInState?.passengers.length > 0
    ) {
      for (let index = 0; index < currentBookingInState?.passengers.length; index += 1) {
        const currentPax = currentBookingInState?.passengers[index];
        if (currentPax.name == null || typeof currentPax.name === "undefined") {
          res = false;
        }
      }
    }
  } catch (error) {
    console.warn(error);
  }
  return res;
}

export const getUpdatedContactDetails = async (bookingInState?: any, isChangeBooking?: any) => {
  try {
    let contactDetails;
    if (isChangeBooking) {
      const bookingData: any = await CurrentBookingInState();
      contactDetails = bookingData?.data?.data?.contacts;
    } else {
      contactDetails = bookingInState?.contacts;
    }
    return findPrimaryContact(contactDetails)
  } catch (err) {
    console.warn("error in fetching contact details", err);
  }
};

export const maxDateSet = (passengerTypeCode: string, date: Date = new Date()) => {
  if (passengerTypeCode === PASSENGER_TYPE.SENIOR_CITIZEN) {
    return new Date(date.setFullYear(date.getFullYear() - 60));
  }
  if (passengerTypeCode === PASSENGER_TYPE.CHILD) {
    date = new Date(date.setFullYear(date.getFullYear() - 2));
    date = new Date(date.setDate(date.getDate() - 1));
    return date;
  }
  if (passengerTypeCode === PASSENGER_TYPE.INFANT) {
    return new Date(date.setDate(date.getDate() - 7));
  }
  return new Date(date.setFullYear(date.getFullYear() - 12)); // atleast 15 year for adult
};

export const minDateSet = (passengerTypeCode: string, date: Date = new Date()) => {
  if (passengerTypeCode === PASSENGER_TYPE.SENIOR_CITIZEN) {
    return new Date(date.setFullYear(date.getFullYear() - 100));
  }
  if (passengerTypeCode === PASSENGER_TYPE.CHILD) {
    date = new Date(date.setFullYear(date.getFullYear() - 12));
    date = new Date(date.setDate(date.getDate() + 1));
    return date;
  }
  if (passengerTypeCode === PASSENGER_TYPE.INFANT) {
    return new Date(date.setFullYear(date.getFullYear() - 2)); // 7 day till 2 years
  }
  return new Date(date.setFullYear(date.getFullYear() - 100));
};

export const minDateSetForInsurance = (passengerTypeCode: string, date: Date = new Date()) => {
  if (passengerTypeCode === PASSENGER_TYPE.SENIOR_CITIZEN) {
    return new Date(date.setFullYear(date.getFullYear() - 70));
  }
  if (passengerTypeCode === PASSENGER_TYPE.CHILD) {
    date = new Date(date.setFullYear(date.getFullYear() - 12));
    date = new Date(date.setDate(date.getDate() + 1));
    return date;
  }
  if (passengerTypeCode === PASSENGER_TYPE.INFANT) {
    return new Date(date.setFullYear(date.getFullYear() - 2)); // 7 day till 2 years
  }
  return new Date(date.setFullYear(date.getFullYear() - 70));
};
